"use strict";
import React, { Component } from 'react';
import { BrowserRouter, Route, Link, Switch } from 'react-router-dom';
import Master from './components/master';
import ComponenteAsync from './components/componente-async';

/* 
const loadHome = () => import('./pages/home/home'); 
const loadFormAddFoto = () => import('./pages/form-add-foto/form-add-foto'); 
 */

//const Home = () => <ComponenteAsync load={() => import('./pages/home/home')} />;

const _carregaAsync = (importPath) => () => <ComponenteAsync load={() => importPath()} />;

const Home = _carregaAsync(() => import('./pages/home/home'));
const FormAddFoto = _carregaAsync(() => import('./pages/form-add-foto/form-add-foto'));
const Regulamento = _carregaAsync(() => import('./pages/regulamento/regulamento'));
const Certificado = _carregaAsync(() => import('./pages/certificado/certificado'));
const Contato = _carregaAsync(() => import('./pages/contato/contato'));
const Inscrevase = _carregaAsync(() => import('./pages/inscrevase/inscrevase'));


var Erro404 = () => (<h2>Página não encontrada</h2>);

//location.pathname

var path = "/facopp/premiofacoppdefotografia/2017/";// window.location.pathname.toLowerCase().indexOf("/Facopp/PremioFacoppFotografia".toLowerCase()) >= 0 ? window.location.pathname.toLowerCase() : "/"
 
class Rotas extends Component {
    render() {
        return (
            <BrowserRouter>
                <Master >
                    <Switch>
                        <Route exact path={path} component={Home} />
                        <Route exact  path={path + "regulamento"} component={Regulamento} />
                        <Route  exact path={path + "uploadFoto"} component={FormAddFoto} />
                        <Route  exact  path={path + "certificado"} component={Certificado} />
                        <Route  exact path={path + "contato"} component={Contato} />                        
                        <Route  exact  path={path + "inscrevase"} component={Inscrevase} />
                        <Route component={Erro404} />
                    </Switch>
                </Master>
            </BrowserRouter>
        );
    }
};


export default Rotas;



// WEBPACK FOOTER //
// ./src/rotas.js